export const pageView = pageObject => ({
  type: 'PAGE_VIEW',
  data: {
    eventName: 'Standard Page View',
    pageObject
  }
});

export const navClick = eventObject => ({
  type: 'NAV_CLICK',
  data: {
    eventName: 'Navigation Item Click',
    eventObject
  }
});

export const fireViewEndCustomEvent = () => {
  const event = new CustomEvent('event-view-end');
  const obj = document.querySelector('body');
  obj.dispatchEvent(event);
};

export const fireViewStartCustomEvent = data => {
  const event = new CustomEvent('event-react-view-start', data);
  document.dispatchEvent(event);
};

export const fireActionTriggerCustomEvent = (
  eventName,
  data,
  target = document.querySelector('body')
) => {
  const event = new CustomEvent(eventName, data);
  target.dispatchEvent(event);
};
